import './applianceSingle.scss';

import GatsbyImageWrapper from '../GatsbyImageWrapper';
import LocalePrice from '@progymedia/gatsby-theme-boutik-ecommerce/src/utils/LocalePrice';
import { LocalizedLink } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import React from 'react';
import arrowIcon from '../../images/icons/Icon-Fleche.svg';
import { popFrontURL } from '../../utils';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useProductPrice } from '@progymedia/gatsby-theme-boutik-ecommerce/src/context/store';
import { useTranslation } from 'react-i18next';

type ApplianceSingleProps = {
    appliance: any;
    isDiscontinued: boolean;
};

export default function ApplianceSingle(props: ApplianceSingleProps) {
    const { code, title, category_localized, slug, attributes, fields } =
        props.appliance;
    const { isDiscontinued } = props;
    const { currentLocale } = usePageLocalization();
    const [price] = useProductPrice(code);
    const displayPrice = currentLocale !== 'en_US' && !isDiscontinued;
    const { t } = useTranslation('pages');

    const linkToAppliancePage = isDiscontinued
        ? `/archives/${code?.toLowerCase()}/parts`
        : popFrontURL(slug?.[currentLocale], 1);

    return (
        <LocalizedLink className='appliance' to={linkToAppliancePage}>
            <div className='appliance-overlay'>
                <p>
                    {t('appliance.see-details')}
                    <br></br>
                    <img className='arrow' alt='' src={arrowIcon} />
                </p>
            </div>
            {attributes.certifications && (
                <div className='appliance-epa-tag'>
                    {getTagText(
                        attributes?.certifications?.values[0]?.['en_CA']
                    )}
                </div>
            )}
            <div className='product-img-wrap'>
                <GatsbyImageWrapper fields={fields} />
            </div>
            <div className='appliance-infos'>
                <span className='code'>{title[currentLocale]}</span>
                <span className='name'>
                    {category_localized?.[currentLocale]?.split('/')[3]}
                </span>
                <span className='area'>
                    {attributes?.Surfi?.values[0][currentLocale]}
                </span>

                {displayPrice && (
                    <span className='price'>
                        {t(`templatePages:appliance-page.starting-at`)}
                        <b>
                            {price?.regularPrice?.value === 0
                                ? '--'
                                : LocalePrice(
                                      currentLocale,
                                      price?.regularPrice?.value
                                  )}
                        </b>
                    </span>
                )}
            </div>
        </LocalizedLink>
    );
}
function getTagText(text: string): string {
    switch (true) {
        case text.includes('EPA'):
            return 'EPA 2020';
        default:
            return '';
    }
}

// "Yes, EPA 2020 approved"
